import { render, staticRenderFns } from "./changeReg.vue?vue&type=template&id=675f2314&scoped=true"
import script from "./changeReg.vue?vue&type=script&lang=js"
export * from "./changeReg.vue?vue&type=script&lang=js"
import style0 from "./changeReg.vue?vue&type=style&index=0&id=675f2314&prod&lang=scss&scoped=true"
import style1 from "./changeReg.vue?vue&type=style&index=1&id=675f2314&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675f2314",
  null
  
)

export default component.exports